import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const AttendeeHomePage = lazy(() => import('./attendee-home-page'));

const AttendeeHomeRoute = () => {
  return (
    <LazyRoute>
      <AttendeeHomePage />
    </LazyRoute>
  );
};

export { AttendeeHomeRoute };
